import { makeStyles } from 'tss-react/mui';

const useStylesContentHeader: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  contentHeader: {
    backgroundColor: theme.palette.primary.light,
    width: 'auto',
    height: 60,
    marginTop: '0 !important',
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
    },
  },
  contentHeaderModal: {
    overflow: 'visible !important',
    marginTop: '0 !important',
    position: 'sticky',
    zIndex: 14,
    top: 0,
  },
  contentHeaderLeftBlock: {
    padding: 10,
  },
  contentHeaderMainBlock: {
    textAlign: 'left',
    fontSize: 20,
    fontWeight: 500,
    padding: 15,
    marginLeft: '10%',
    [theme.breakpoints.down('md')]: {
      marginLeft: '20%',
    },
  },
  contentHeaderMainBlockNoLeft: {
    marginLeft: 0,
  },
  contentHeaderMainBlockModal: {
    '& > div:last-of-type': {
      marginLeft: 10,
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      width: 'calc(100% + 30px)',
      height: 20,
      top: -20,
      left: -20,
      zIndex: 11,
      backgroundColor: theme.palette.background.default,
    },
  },
  contentHeaderImage: {
    float: 'left',
    marginTop: -5,
    marginRight: 15,
  },
  contentHeaderTitle: {
    '& > div, & > span > div': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 150,
    },
  },
  contentHeaderTitleBlockCentered: {
    margin: '0 auto',
    textAlign: 'center',
    paddingRight: 30,
  },
  contentHeaderTitleBlockModal: {
    '& > div': {
      width: 'calc(100% - 60px)',
    },
  },
  contentHeaderTitleBlockModalExtended: {
    paddingRight: 100,
    '& > div': {
      width: 'calc(100% - 130px)',
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100% - 80px)',
      },
    },
  },
  contentHeaderButtons: {
    marginTop: -40,
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      marginRight: -15,
    },
  },
}));

export default useStylesContentHeader;
